import { waitForMs } from '@Utils/miscUtils';
import { useClassStore } from '@Utils/useClassStore';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { injectable, postConstruct } from 'inversify';
import { action, observable } from 'mobx';

import { SHOP_FLOOR_WELCOME_BLURB_SHOWN } from '~config/storage';
import container from '~ioc/ioc';

type ISetWelcomeBlurbShownArgs = {
  value: boolean;
  persistToStorage?: boolean;
};

@injectable()
class ShopFloorWelcomeBlurPresenter {
  @postConstruct() postConstruct() {
    this.init().then();
  }

  private init = async () => {
    const isShown = await AsyncStorage.getItem(SHOP_FLOOR_WELCOME_BLURB_SHOWN);
    if (!isShown || isShown === 'false') {
      await waitForMs(3000);
      this.welcomeBlurbShown = false;
      await this.scheduleClosingWelcomeMessage();
      return;
    }
    this.welcomeBlurbShown = true;
  };

  // We set this as true to begin with so the blurb is hidden until we know what value is set in storage
  @observable public welcomeBlurbShown: boolean = true;

  @action private setWelcomeBlurbShown = ({
    value = false,
    persistToStorage = false,
  }: ISetWelcomeBlurbShownArgs) => {
    if (persistToStorage) {
      AsyncStorage.setItem(
        SHOP_FLOOR_WELCOME_BLURB_SHOWN,
        value.toString()
      ).then();
    }
    this.welcomeBlurbShown = value;
  };

  private scheduleClosingWelcomeMessage = async () => {
    await waitForMs(5000);
    this.setWelcomeBlurbShown({
      value: true,
      persistToStorage: true,
    });
  };

  @action public onWelcomeOverlayClick = () => {
    this.setWelcomeBlurbShown({
      value: true,
      persistToStorage: true,
    });
  };
}
export const useShopFloorWelcomeBlurPresenter = () =>
  useClassStore<ShopFloorWelcomeBlurPresenter>(
    container.get(ShopFloorWelcomeBlurPresenter)
  );
